import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          projectName: "Project name",
          grade: 'Grade',
          subjects: 'Subjects',
          structureType: 'Structure Type',
          projectCreationForm: 'PROJECT CREATION FORM',
          projectNamePlaceHolder: 'Type a project name...',
          abp: 'Problem-based learning',
          invertedClassroom: 'Inverted Classroom',
          TemaClaseTitle: "Tema de la clase *",
          TemaClaseDescription: "Describe el tema o propósito de la clase",
          TemaClasePlaceholder: "Escribe el tema de la clase aquí. Ejemplo: Efectos de la actividad humana en ecosistemas"
        }
      },
      es: {
        translation: {
          projectName: "Tema del proyecto",
          grade: 'Grado',
          subjects: 'Materias',
          structureType: 'Tipo de estructura',
          projectCreationForm: 'FORMULARIO CREACIÓN DE PROYECTO',
          projectNamePlaceHolder: '',
          abp: 'ABP',
          invertedClassroom: 'Aula invertida',
          TemaClaseTitle: "Tema de la clase *",
          TemaClaseDescription: "Describe el tema o propósito de la clase",
          TemaClasePlaceholder: "Escribe el tema de la clase aquí. Ejemplo: Efectos de la actividad humana en ecosistemas"
        }
      },
      cl: {
        translation: {
          nivel: 'Nivel *',
          asignatura: 'Asignatura *',
          tipo: 'Tipo',
          objetivoAprendizaje: 'Objetivo de aprendizaje',
          indicadores: 'Indicadores',
          apoderado: 'apoderado',
          apoderados: 'apoderados',
          mensajeApoderadoTitle: 'Mensaje al apoderado',
          placeholderDestinatario: 'Escribe aquí el destinatario del mensaje. Ejemplo: Apoderados',
          claseDiferenciadaTitle: 'Clase Diferenciada',
          TemaClaseTitle: "Tema de la clase *",
          TemaClaseDescription: "Describe el tema o propósito de la clase",
          TemaClasePlaceholder: "Escribe el tema de la clase aquí. Ejemplo: Efectos de la actividad humana en ecosistemas"
        }
      },
      arg: {
        translation: {
          nivel: 'Año *',
          asignatura: 'Materia *',
          tipo: 'Tipo',
          objetivoAprendizaje: 'Objetivo de aprendizaje',
          indicadores: 'Indicadores',
          apoderado: 'apoderado',
          apoderados: 'apoderados',
          mensajeApoderadoTitle: 'Mensaje al apoderado',
          placeholderDestinatario: 'Escribe aquí el destinatario del mensaje. Ejemplo: Apoderados',
          claseDiferenciadaTitle: 'Clase Diferenciada',
          TemaClaseTitle: "Tema de la clase *",
          TemaClaseDescription: "Describe el tema o propósito de la clase",
          TemaClasePlaceholder: "Escribe el tema de la clase aquí. Ejemplo: Efectos de la actividad humana en ecosistemas"
        }
      },
      pe: {
        translation: {
          nivel: 'Grados *',
          asignatura: 'Áreas curriculares *',
          tipo: 'Competencia',
          objetivoAprendizaje: 'Capacidad',
          indicadores: 'Desempeños',
          apoderado: 'padre de familia',
          apoderados: 'padres de familia',
          mensajeApoderadoTitle: 'Mensaje a familias',
          placeholderDestinatario: 'Escribe aquí el destinatario del mensaje. Ejemplo: Padres de familia',
          claseDiferenciadaTitle: 'Planificación para la inclusión',
          TemaClaseTitle: "Tema de la clase *",
          TemaClaseDescription: "Describe el tema o propósito de la clase",
          TemaClasePlaceholder: "Escribe el tema de la clase aquí. Ejemplo: Efectos de la actividad humana en ecosistemas"
        }
      },
      uy: {
         translation: {
        nivel: 'Año *',
        asignatura: 'Áreas curriculares *',
        tipo: 'Competencia',
        objetivoAprendizaje: 'Capacidad',
        indicadores: 'Desempeños',
        apoderado: 'padre de familia',
        apoderados: 'padres de familia',
        mensajeApoderadoTitle: 'Mensaje a familias',
        placeholderDestinatario: 'Escribe aquí el destinatario del mensaje. Ejemplo: Padres de familia',
        claseDiferenciadaTitle: 'Planificación para la inclusión',
        TemaClaseTitle: "Meta de aprendizaje *",
        TemaClaseDescription: "Describe la meta de aprendizaje",
        TemaClasePlaceholder: "Escribe la meta de aprendizaje aquí. Ejemplo: Efectos de la actividad humana en ecosistemas"
         }
      }
    },
    lng: "es", // idioma por defecto
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
